module.exports = "/_next/static/images/ourPartnersLogo2-f78faf8eb7b24f5f6b4f7ac3fa184731.webp";